<template>
    <fade-up-animation :element="() => $refs.section">
        <div class="sitemap-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <section
                        v-for="section in sections"
                        :key="section.title"
                        class="section"
                        v-test:section
                    >
                        <h2
                            class="h5"
                            v-test:title
                        >
                            {{ section.title }}
                        </h2>

                        <b-row tag="ol">
                            <b-col
                                v-for="page in section.pages"
                                :key="page.id"
                                tag="li"
                                :sm="section.pages.length > 5 ? 6 : 12"
                                v-test:column
                            >
                                <nuxt-link
                                    :to="page.uri"
                                    v-test:link
                                >
                                    {{ page.title }}
                                </nuxt-link>
                            </b-col>
                        </b-row>
                    </section>
                </mobile-gutter>
            </b-container>
        </div>
    </fade-up-animation>
</template>

<script>
    export default {
        name: 'sitemap-section',

        props: {
            sections: {
                type: Array,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .sitemap-section {
        padding: 75px 0;
    }

    h2 {
        border-bottom-width: 2px;
        border-bottom-style: solid;
        border-color: inherit;
        padding-bottom: 4px;
        margin-bottom: 0.5em;
    }

    ol {
        list-style: none;
        padding: 0;
    }

    li {
        padding-top: 5px;
        padding-bottom: 5px;
        font-size: rem(18px);
    }

    .section {
        margin-bottom: 4rem;

        &:last-child {
            margin-bottom: 0;
        }
    }
</style>
